
export const PMHSystems = (): Array<string> => ([
  'CVS',
  'Respiratory',
  'UGT',
  'CNS',
  'GIT',
  'Gynaecological',
  'Reproductive',
  'MSK',
  'Endocrine',
  'Haematological',
  'Psychiatric'
].sort((a, b) => a.localeCompare(b)));

export const PMHTypes = (): Array<string> => ([
  'Acute',
  'Chronic'
]);